import React, { Component, Fragment } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import "moment/locale/es";
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import history from '../../../../history';

class ClinicHistoryFull extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pacient: {},
            admissions: [],
            loading: true,
            age: '',
            date: '',
            dataAdmision: null
        }
    }

    componentDidMount() {
        this.getClinicHistory();
    }

    calculateAge = (birthday) => {
        

        let hoy = new Date();
        let cumpleanos = new Date(birthday);

        let edad = hoy.getFullYear() - cumpleanos.getFullYear();

        let meses = hoy.getMonth() - cumpleanos.getMonth();
        

        if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }        

        let cantMeses = meses;

        if(meses < 0){
            cantMeses = 12 + meses;
        }

        let edadTotal = edad + ' años ' + cantMeses + ' meses';

        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
        let nacimiento = moment(birthday).format("YYYY-MM-DD");

        this.setState({ age: edadTotal, date: nacimiento });
    }

    getClinicHistory = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + this.props.data.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                this.calculateAge(data.paciente.fec_nacimiento);
                this.filterData(data.admisiones)
                this.setState({ pacient: data.paciente });

            })
            .catch((error) => {
                alert(error);
                console.error('Error:', error);
            });
    }

    filterData = (data) => {

        let mainData = [];

        //for (let obj of data) {
        for (let i = (data.length - 1); i >= 0; i--) {
            //
            if (typeof data[i].anamnesis !== 'undefined' && typeof data[i].antecedentes !== 'undefined' && typeof data[i].fisico !== 'undefined' && typeof data[i].plan !== 'undefined') {
                mainData.push(data[i]);
            }
        }

        this.setState({ admissions: mainData, loading: false });
    }

    render() {

        return (
            <Card>
                <Col md={12}>
                    <Button
                        style={{ marginBottom: 20 }}
                        variant="contained"
                        color="primary"
                        size="sm"
                        onClick={() => {
                            history.push({
                                pathname: process.env.PUBLIC_URL + '/assitencial/search-clinic-history',
                                state: { date: this.props.data.fecha }
                            });
                        }}
                    ><ArrowBackIcon />
                    </Button>
                </Col>
                <TextField
                    className="material-form__field"
                    label="Admision"
                    id="admision-select"
                    style={{ width: 200 }}
                    select
                    defaultValue={null}
                    onChange={(event) => {
                        this.setState({ dataAdmision: event.target.value });
                    }}
                >
                    {this.state.admissions.map((admision) => {
                        return <MenuItem className="material-form__option" key={admision.id_admision} value={admision}>{admision.fecha}</MenuItem>
                    })}
                </TextField>
                <CardBody>
                    <Col>
                        {this.state.loading ?
                            <div style={{ alignItems: 'center' }}>
                                <Spinner animation="border" variant="success" />
                            </div> :
                            <div>
                                <h4 style={{ marginBottom: 20 }} >Paciente</h4>
                                <div style={{ marginBottom: 10 }}>
                                    <Row>
                                        <Col md={6} sm={12}>
                                            <h5> <b> Nombre: </b> {this.state.pacient.nombres}  {this.state.pacient.apellido1}  {this.state.pacient.apellido2} </h5>
                                        </Col>
                                        <Col md={6} sm={12}>
                                            <h5> <b> Documento: </b> {this.state.pacient.tip_documento}-{this.state.pacient.num_documento}</h5>
                                        </Col>
                                    </Row>
                                </div>
                                <div style={{ marginBottom: 10 }}>
                                    <Row>
                                        <Col md={6} sm={12}>
                                            <h5> <b> Fecha de Nacimiento: </b> {this.state.date}   </h5>
                                        </Col>
                                        <Col md={6} sm={12}>
                                            <h5> <b>  Edad: </b> {this.state.age}</h5>
                                        </Col>
                                    </Row>
                                </div>
                                <div style={{ marginBottom: 10 }}>
                                    <Row>
                                        <Col md={6} sm={12}>
                                            <h5> <b> Genero: </b> {this.state.pacient.sexo}   </h5>
                                        </Col>
                                        <Col md={6} sm={12}>
                                            <h5> <b>  Tipo de Sangre: </b> {this.state.pacient.tipo_sangre}</h5>
                                        </Col>
                                    </Row>
                                </div>

                            </div>
                        }
                        {this.state.dataAdmision !== null ?
                            <div>
                                <h4 style={{ marginTop: 40 }} >Anamesis</h4>

                                <Row >                                    
                                    <Col md={6} sm={12}>
                                        <h5> <b> Motivo de Consulta: </b> {this.state.dataAdmision.anamnesis.motivo_consulta}  </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b>  Enfermedad Actual: </b> {this.state.dataAdmision.anamnesis.enfermedad_actual} </h5>
                                    </Col>
                                </Row>
                                <h4 style={{ marginTop: 40 }} >Antecedentes Personales</h4>
                                <h5 style={{ marginTop: 10 }} ><b>Patologicos</b></h5>

                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Cancer: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].cancer.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Diabetes: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].diabetes.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b>  Enf Coronaria: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].enf_coronaria.value} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Hepatitis: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].hepatitis.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Transfusiones: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].transfusiones.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b>  Enf Vascular Periferica: </b> {this.state.dataAdmision.antecedentes.patologicos.patologicos[0].enf_vascular_periferica.value} </h5>
                                    </Col>
                                </Row>
                                <Row  style={{ marginTop: 50 }}>
                                        <Col xs="3" >
                                            <h5> <b> Quirurgicos: </b> {this.state.dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.value}  </h5>
                                        </Col>
                                        <Col >
                                            {typeof this.state.dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.table !== 'undefined' ?
                                            <table className="table table--bordered">
                                                 <thead>
                                                        <tr>
                                                            <td >Tipo  </td>
                                                            <td >Nombre</td>
                                                            <td >Fecha </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.table.map((data, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{data.tipo}</td>
                                                                    <td>{data.nombre}</td>
                                                                    <td>{data.fecha}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                               </table> :
                                            <h5> {this.state.dataAdmision.antecedentes.quirurgicos.quirurgicos[0].quirurgico.comentario}  </h5>}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 50 }}>
                                        <Col xs="3" >
                                            <h5> <b> Farmacológicos: </b> {this.state.dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.value}  </h5>
                                        </Col>
                                        <Col >
                                            {typeof this.state.dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.table !== 'undefined' ?

                                                <table className="table table--bordered">
                                                    <thead>
                                                        <tr>
                                                            <td >Principio Activo  </td>
                                                            <td >Fecha Inicio </td>
                                                            <td >Fecha Fin </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.dataAdmision.antecedentes.farmacologicos.farmacologicos[0].farmacologico.table.map((data, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{data.principioactivo + " " + data.concentracion}</td>
                                                                    <td>{data.fecha_inico}</td>
                                                                    <td>{data.fecha_fin}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                                : ""}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 50 }}>
                                        <Col xs="3" >
                                            <h5> <b>  Inmunizaciones: </b> {this.state.dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.value} </h5>
                                        </Col>
                                        <Col >
                                            {typeof this.state.dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.table !== 'undefined' ?
                                                <table className="table table--bordered">
                                                    <thead>
                                                        <tr>
                                                            <td >Vacuna </td>
                                                            <td >Fecha </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.dataAdmision.antecedentes.inmunizaciones.inmunizaciones[0].inmunizaciones.table.map((data, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{data.vacuna}</td>
                                                                    <td>{data.fecha}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                                : ""}
                                        </Col>
                                    </Row>
                                <h4 style={{ marginTop: 40 }} > Antecedentes Familiares</h4>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Cancer: </b> {this.state.dataAdmision.antecedentes.familiares.familiares[0].cancer.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Diabetes: </b> {this.state.dataAdmision.antecedentes.familiares.familiares[0].diabetes.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b>  Enf Coronaria: </b> {this.state.dataAdmision.antecedentes.familiares.familiares[0].enf_coronaria.value} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Hipertension: </b> {this.state.dataAdmision.antecedentes.familiares.familiares[0].hipertension.value}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Muerte Subita: </b> {this.state.dataAdmision.antecedentes.familiares.familiares[0].muerte_subita.value}  </h5>
                                    </Col>
                                    <Col >

                                    </Col>
                                </Row>
                                <h4 style={{ marginTop: 20 }} > Antecedentes Habitos</h4>
                                <Row xs="3" style={{ marginTop: 20 }}>
                                        <Col >
                                            <h5> <b> Fumador: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].fumador}  </h5>
                                        </Col>
                                        <Col >
                                            <h5> <b> Paquetes / año </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].paquetes_anio}  </h5>
                                        </Col>
                                        <Col >
                                            <h5> <b>  Año de inicio: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].ano_inicio} </h5>
                                        </Col>
                                    </Row>
                                    <Row xs="3" style={{ marginTop: 20 }}>
                                        <Col >
                                            <h5> <b> Consumo de Alcohol: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].alcohol}  </h5>
                                        </Col>
                                        <Col >
                                            <h5> <b> Frecuencia: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].alcohol_frecuencia}  </h5>
                                        </Col>

                                    </Row>
                                    <Row xs="3" style={{ marginTop: 20 }}>
                                        <Col >
                                            <h5> <b> Sustancias Psicoactivas: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].sustancia_psico}  </h5>
                                        </Col>
                                        <Col >
                                            <h5> <b> Frecuencia: </b> {this.state.dataAdmision.antecedentes.habitos.habitos[0].sustancia_frecuencia}  </h5>
                                        </Col>

                                    </Row>
                                {this.state.dataAdmision.tratamiento.ordenes.ordenes.addedDiagnostics.length > 0 ?
                                    <Fragment>
                                        <h4 style={{ marginTop: 40 }} > Procedimeintos</h4>
                                        <Row style={{ marginTop: 10 }}>
                                            <table className="table table--bordered" >
                                                <thead>
                                                    <tr>
                                                        <td >Codigo  </td>
                                                        <td >Nombre </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.dataAdmision.tratamiento.ordenes.ordenes.addedDiagnostics.map((orden, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{orden.cupscod}</td>
                                                                <td>{orden.cupsnom}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Row>
                                    </Fragment>
                                    : null
                                }
                                <h4 style={{ marginTop: 40 }} > Examen Físico</h4>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Peso: </b> {this.state.dataAdmision.fisico.peso + " (kg)"}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Talla: </b> {this.state.dataAdmision.fisico.talla}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Superficie Corporal: </b> {this.state.dataAdmision.fisico.superficie_corporal + ' (mc)'} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> Índice de Masa Corporal: </b> {this.state.dataAdmision.fisico.masa_corporal}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Frecuencia Cardiaca: </b> {this.state.dataAdmision.fisico.frecuencia_cardiaca + ' (lpm)'}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Frecuencia Respiratoria: </b> {this.state.dataAdmision.fisico.frecuencia_respiratoria + ' (resp/min)'} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b>Presiona Arterial: </b> {this.state.dataAdmision.fisico.presion_arterial + ' (mm/Hg)'}  </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 25 }}>
                                    <Col >
                                        <h5> <b>Aspecto General: </b> {this.state.dataAdmision.fisico.aspecto_general}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Cabeza y Cara: </b> {this.state.dataAdmision.fisico.cabeza_cara}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Otorino: </b> {this.state.dataAdmision.fisico.otorrino} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b>Ojos: </b> {this.state.dataAdmision.fisico.ojos}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Cuello: </b> {this.state.dataAdmision.fisico.cuello}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Torax: </b> {this.state.dataAdmision.fisico.torax} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b>Cardiovascular: </b> {this.state.dataAdmision.fisico.cardiovascular}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Pulmonar: </b> {this.state.dataAdmision.fisico.pulmonar}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Abdomen: </b> {this.state.dataAdmision.fisico.abdomen} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b>Extremidades: </b> {this.state.dataAdmision.fisico.extremidades}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Neurologico: </b> {this.state.dataAdmision.fisico.neurologico}  </h5>
                                    </Col>
                                    <Col >
                                        <h5> <b> Genitourinatio: </b> {this.state.dataAdmision.fisico.genitourinario} </h5>
                                    </Col>
                                </Row>
                                <Row xs="3" style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b>Piel y Fanareas: </b> {this.state.dataAdmision.fisico.piel_faneras}  </h5>
                                    </Col>
                                </Row>

                                {this.state.dataAdmision.diagnostico.diagnostico.diagnostico.length > 0 ?
                                    <Fragment>
                                        <h4 style={{ marginTop: 40 }} > Diagnosticos</h4>
                                        <Row style={{ marginTop: 10 }}>
                                        <table className="table table--bordered" >
                                                <thead>
                                                    <tr>
                                                        <td >Código  </td>
                                                        <td >Nombre </td>                                                       
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.dataAdmision.diagnostico.diagnostico.diagnostico.map((diagnostico, index) => {                                                        
                                                        return (
                                                            <tr key={index}>
                                                                <td> {diagnostico.codigo}</td>
                                                                <td> {diagnostico.nombre}</td>                                                                
                                                            </tr>

                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Row>
                                    </Fragment>
                                    : null}

                                {this.state.dataAdmision.tratamiento.tratamiento.tratamiento.length > 0 ?
                                    <Fragment>
                                        <h4 style={{ marginTop: 40 }} > Ordenes Medicas</h4>
                                        <Row style={{ marginTop: 10 }}>
                                            <table className="table table--bordered" >
                                                <thead>
                                                    <tr>
                                                        <td >Principio Activo  </td>
                                                        <td >Vía de Administración </td>
                                                        <td >Frecuencia </td>
                                                        <td >Dosis </td>
                                                        <td >Duracion </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.dataAdmision.tratamiento.tratamiento.tratamiento.map((orden, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td> {orden.principio_activo + " " + orden.concentracion}</td>
                                                                <td> {orden.via_administracion}</td>
                                                                <td> {orden.frecuencia}</td>
                                                                <td> {orden.dosis}</td>
                                                                <td> {orden.duracion + " días"}</td>
                                                            </tr>

                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Row>
                                    </Fragment>
                                    : null
                                }

                                <h4 style={{ marginTop: 60 }} > Médico Tratante</h4>
                                <Row style={{ marginTop: 10 }}>
                                    <Col >
                                        <h5> <b> {this.state.dataAdmision.nombres + " " + this.state.dataAdmision.apellido1} </b> </h5>
                                        <h5> <b> {this.state.dataAdmision.especialidad}  </b></h5>
                                        <h5> <b> {this.state.dataAdmision.reg_medico}  </b></h5>
                                    </Col>
                                </Row>


                            </div>
                            : null
                        }
                    </Col>

                </CardBody>
            </Card>

        );

    }
}

export default ClinicHistoryFull;
